module.exports = {

	search_input_placeholder: {
		it: 'CERCA PRODOTTI O CATEGORIE',
		en: 'SEARCH FOR PRODUCTS OR CATEGORIES',
		ru: 'ПОИСК ПРОДУКЦИИ ИЛИ КАТЕГОРИЙ',
	},

	home_header_title: {
		it: 'Soluzioni all\'avanguardia per i veicoli trasporto passeggeri',
		en: 'State-of-the-art solutions for mass transportation vehicles',
		ru: 'Современные решения для транспортных средств массового передвижения',
	},

	home_certification_title: {
		it: 'Costante ricerca della qualità, automazione dei processi, attenzione al cliente, cura dell\'ambiente e del welfare aziendale',
		en: 'Constantly researching for quality, process automation, customer care, care for the environment and for the corporate welfare',
		ru: 'Постоянное исследование и улучшение качества автоматизационных процессов, забота о корпоративном благополучии и особое внимание и обязательство перед клиентами и окружающей средой.',
	},

	home_intro_text: {
		it: 'PRIMA Automotive è uno dei più importanti produttori europei di articoli per veicoli industriali e progetta, produce e distribuisce in tutto il mondo componenti e sistemi complessi destinati a costruttori di veicoli per il trasporto pubblico di passeggeri, di macchine operatrici industriali ed agricole, ai settori collaterali come i produttori di cruscotti, cabine ed impianti di condizionamento, arrivando a punte di eccellenza con forniture di particolari esclusivi verso produttori di Super Cars.',
		en: 'Prima Automotive, is one of the most important European manufacturers of components for the automotive and industrial vehicles market designing, developing and distributing all over the World plastic injection molded items for manufacturers of mass transportation vehicles, industrial and agricultural machinery, manufacturers of dashboards, cabins and air conditioning systems reaching to high valuated supplies for Super car producers at whom we supply exclusive designed items.',
		ru: 'Prima Automotive является одним из ведущих европейских производителей промышленной автомобильной продукции и конструкций. Стабильно развивается на рынке авто комплектующих, производит и распространяет сложные компоненты и системы по всему миру для производителей общественных пассажирских транспортных средств, машин промышленных и сельскохозяйственных, а так же для производителей приборных панелей, кабин и систем кондиционирования воздуха, достигая  вершин совершенства, поставляя эксклюзивные запчасти производителям Super Car.',
	},

	discover_more: {
		it: 'Scopri di più',
		en: 'Discover more',
		ru: 'УЗНАТЬ БОЛЬШЕ',
	},

	view_more: {
		it: 'Vedi di più',
		en: 'View more'
	},

	view_less: {
		it: 'Chiudi',
		en: 'View less'
	},

	view_all: {
		it: 'Vedi tutti',
		en: 'View all'
	},

	// Applicazioni
	autobus: {
		it: 'Autobus',
		en: 'Coaches',
		ru: 'автобус',
	},

	minibus: {
		it: 'Mini-bus',
		en: 'Mini-bus',
		ru: 'мини-автобус',
	},

	citybus: {
		it: 'Bus urbani',
		en: 'Mini-bus',
		ru: 'мини-автобус',
	},

	industrial_vehicles: {
		it: 'Veicoli industriali',
		en: 'Industrial vehicles',
		ru: 'промышленные транспортные средства',
	},

	special_vehicles: {
		it: 'Veicoli speciali',
		en: 'Special vehicles',
		ru: 'транспортные средства особого назначения',
	},

	underground: {
		it: 'Metropolitana e treni',
		en: 'Underground rail railways',
		ru: 'метро и поезда',
	},

	wellness: {
		it: 'Wellness',
		en: 'Wellness',
		ru: 'ОЗДОРОВЛЕНИЕ',
	},

	// product page GUI

	automotive_components: {
		it: 'Componenti per l\'automotive',
		en: 'Automotive components',
		ru: 'Автокомпоненты',
	},

	technical_features: {
		it: 'Specifiche tecniche',
		en: 'Technical features',
		ru: 'Технические характеристики',
	},

	ask_for_info: {
		it: 'Richiedi informazioni',
		en: 'Ask for information',
		ru: 'ЗАПРОСИТЬ ИНФОРМАЦИЮ',
	},

	download_tech_sheet: {
		it: 'Scarica scheda tecnica',
		en: 'Download tech sheet',
		ru: 'ЗАГРУЗИТЬ СПЕЦИФИКАЦИЮ',
	},

	download_manual: {
		it: 'Scarica il manuale',
		en: 'Download manual',
		ru: 'ЗАГРУЗИТЬ РУКОВОДСТВО',
	},

	manual_not_available: {
		it: 'Spiacente, per questo prodotto non è disponibile il manuale.',
		en: 'Sorry, no manual available for this product.',
		ru: 'Sorry, no manual available for this product.',
	},

	check_technical_sheet: {
		it: 'Consulta la scheda tecnica',
		en: 'View the technical sheet',
		ru: 'View the technical sheet',
	},

	download_jok_manual: {
		it: 'Manuale del JOK System',
		en: 'JOK System manual',
		ru: 'JOK System manual',
	},

	other_documents: {
		it: 'Altri documenti',
		en: 'Other documents',
		ru: 'ДРУГИЕ ДОКУМЕНТЫ',
	},

	all_products: {
		it: 'Tutti i prodotti',
		en: 'All products',
		ru: 'все продукты',
	},

	all_categories: {
		it: 'Tutte le categorie',
		en: 'All categories',
		ru: 'все категории',
	},

	download_full_catalogue: {
		it: 'SCARICA',
		en: 'DOWNLOAD',
		ru: 'ЗАГРУЗИТЬ ПОЛНУЮ ВЕРСИЮ КАТАЛОГА',
	},

	directives_and_regulations: {
		it: 'Direttive e regolamenti',
		en: 'Directives and regulations',
		ru: 'ДИРЕКТИВЫ И ПРАВИЛА',
	},

	recently_viewed_product: {
		it: 'Prodotti visti di recente',
		en: 'RECENTLY VIEWED PRODUCTS',
		ru: 'НЕДАВНО ПРОСМОТРЕННЫЕ ПРОДУКТЫ',
	},

	interested_in_this: {
		it: 'Interessato a questo prodotto ?',
		en: 'interested in this product ?',
		ru: 'Вы заинтересованы в этом продукте?',
	},

	interested_in_this_group: {
		it: 'Interessato a questi prodotti ?',
		en: 'Interested in these products?',
		ru: 'Заинтересованы в этих продуктах?',
	},

	// Contacts page
	contact_form_title: {
		it: 'Siamo qui per aiutarti',
		en: 'We are here to help you',
		ru: 'Mы здесь, чтобы помочь вам',
	},

	name_label: {
		it: 'Nome',
		en: 'Name',
		ru: 'Имя',
	},

	surname_label: {
		it: 'Cognome',
		en: 'Surname',
		ru: 'Фамилия',
	},

	nation_label: {
		it: 'Nazione',
		en: 'Nation',
		ru: 'Страна',
	},

	company_label: {
		it: 'Azienda',
		en: 'Company',
		ru: 'Компании',
	},

	email_label: {
		it: 'Indirizzo email',
		en: 'Email address',
		ru: 'Адрес электронной почты',
	},

	website_label: {
		it: 'Sito web',
		en: 'Website',
		ru: 'Сайт',
	},

	city_label: {
		it: 'Città',
		en: 'City',
		ru: 'Город',
	},

	cap_label: {
		it: 'CAP',
		en: 'ZIP Code',
		ru: 'Индекс',
	},

	select_subject: {
		it: 'Seleziona il soggetto',
		en: 'Select subject',
		ru: 'Выберите тему'
	},

	subject_job_opportunities: {
		it: 'Opportunità lavorative',
		en: 'Job opportunities',
		ru: 'Вакансии/сотрудничество',
	},

	subject_tech_support: {
		it: 'Supporto tecnico',
		en: 'Technical support',
		ru: 'Техническая поддержка',
	},

	subject_general_informations: {
		it: 'Informazioni generali',
		en: 'General informations',
		ru: 'Общие сведения'
	},

	subject_product_informations: {
		it: 'Informazioni sul prodotto',
		en: 'Informations about product',
		ru: 'Сведения о продукте',
	},

	subject_business_proposal: {
		it: 'Proposte di collaborazione',
		en: 'Business proposal',
		ru: 'Business proposal',
	},


	write_message: {
		it: 'Scrivi il messaggio',
		en: 'Write your message',
		ru: 'Написать сообщение',
	},

	send_butt: {
		it: 'Invia',
		en: 'Send',
		ru: 'Отправить',
	},

	// Teams
	team: {
		it: 'Team',
		en: 'Team',
		ru: 'Команда',
	},

	plant_manager: {
		it:'Dir. Stabilimento, Resp. Acquisti',
		en:'Plant Manager, Supply Man.',
		ru:'Управляющий, менеджер по закупкам',
	},

	quality_manager: {
		it: 'Resp. Sistema Integrato (Qualità, Ambiente e Sicurezza)',
		en: 'Integrated System Manager (Quality, Environment and Security)',
		ru: 'Менеджер интегрированной системы (качество, окружающая среда, безопаснось)',
	},

	customer_service: {
		it: 'Assistenza Clienti',
		en: 'Customer service',
		ru: 'Поддержка клиентов',
	},

	clients_administration: {
		it: 'Amministrazione clienti',
		en: 'Clients administration',
		ru: 'Управление клиентами',
	},

	technical_assistance: {
		it: 'Supporto prodotto, Assistenza tecnica',
		en: 'Technical Assistance',
		ru: 'Поддержка по продукту, техническая помощь',
	},

	transport_logistics: {
		it: 'Spedizioni & Logistica',
		en: 'Transport & Logistics',
		ru: 'Доставка и логистика',
	},

	commercial_director: {
		it: 'Sales & Marketing manager',
		en: 'Sales & Marketing manager',
		ru: 'Коммерческий директор',
	},

	area_1: {
		it: 'Asia, Oceania, America, Europa Occidentale*',
		en: 'Asia, Oceania, America, Western Europe*',
		ru: 'Азия, Океания, Америка, Западная Европа',
	},

	area_2: {
		it: '*Norvegia, Svezia, Islanda, Danimarca, Finlandia',
		en: '*Norway, Sweden, Iceland, Denmark, Finland',
		ru: 'Норвегия, Швеция, Исландия, Дания, Финляндия',
	},

	area_3: {
		it: 'Italia, San Marino, Europa dell’Est, Europa Occidentale **',
		en: 'Italy, San Marino, Eastern Europe, Western Europe **',
		ru: 'Италия, Сан-Марино, Восточная и Западная Европа',
	},

	area_4: {
		it: '**Austria, Germania, Svizzera',
		en: '**Austria, Germany, Switzerland',
		ru: 'Австрия, Германия, Швейцария',
	},

	area_5: {
		it: 'Medio Oriente, Africa, Europa Occidentale ***',
		en: 'Middle East, Africa, Western Europe ***',
		ru: 'Средний Восток, Африка, Западная Европа',
	},

	area_6: {
		it: '***Irlanda, Francia, Spagna, Portogallo, Benelux, Grecia, Cipro, Malta, Regno Unito',
		en: '***Ireland, France, Spain, Portugal, Benelux, Greece, Cyprus, Malta, United Kingdom',
		ru: 'Ирландия, Франция, Испания, Португалия, Бенилюкс, Греция, Кипр, Мальта, Великобритания',
	}

}



// WEBPACK FOOTER //
// ./assets/js/partials/translations.js